import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ConsultingSection from './components/ConsultingSection';
import PortfolioSection from './components/PortfolioSection';
import AutomationSection from './components/AutomationSection';
// import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ContactFormSection from './components/ContactFormSection';
import FooterSection from './components/FooterSection';
import OurThoughtsSection from './components/OurThoughtsSection';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const schemaOrg = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: '株式会社Y\'s STUDIO',
      description: '神戸のWeb制作会社。営業視点で導線を設計し、成果につながるWebサイトをスピーディーに構築。',
      inLanguage: 'ja',
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#localbusiness`,
      name: '株式会社Y\'s STUDIO',
      url: `${SITE_URL}/`,
      telephone: '090-2199-3209',
      email: 'ysstudio.kobe@gmail.com',
      description: '神戸のWeb制作会社。営業視点で導線を設計し、成果につながるWebサイトをスピーディーに構築。SNS自動投稿・業務自動化・LP制作もワンストップで対応。',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '琵琶町2-3-6',
        addressLocality: '神戸市灘区',
        addressRegion: '兵庫県',
        postalCode: '657-0041',
        addressCountry: 'JP',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 34.7024,
        longitude: 135.2196,
      },
      areaServed: '神戸市',
      priceRange: '¥¥',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
      sameAs: [],
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: '神戸Web制作 株式会社Y\'s STUDIO｜売れる仕組みから考えるWebサイト制作',
      description: '神戸のWeb制作会社 株式会社Y\'s STUDIO。営業視点で導線を設計し、成果につながるWebサイトをスピーディーに構築。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${SITE_URL}/#website` },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaOrg);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div id="hero">
        <HeroSection />
      </div>
      <div id="about">
        <AboutSection />
      </div>
      <div id="consulting">
        <ConsultingSection />
      </div>
      <div id="portfolio">
        <PortfolioSection />
      </div>
      <div id="automation">
        <AutomationSection />
      </div>
      <CTASection />
      <div id="faq">
        <FAQSection />
      </div>
      <div id="thoughts">
        <OurThoughtsSection />
      </div>
      
      {/* お問い合わせ前のメッセージ */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-navy leading-relaxed">
            Webを作るのではなく、<br />
            成果につながる設計を。<br />
            Y's STUDIOが伴走します。
          </h2>
        </div>
      </section>
      
      <div id="contact">
        <ContactFormSection />
      </div>
      <FooterSection />
    </div>
  );
}